import { UiTemplateGalleryModel } from "../../models";

import { mockTrelloTemplateModel } from "./mock-trello-template";

export function mockUiTemplateGalleryModel({
    id = "ui-template-gallery-1234",
    type = "uiTemplateGallery",
    locale = "en",
    content = mockUiTemplateGalleryModelContent()
}: Partial<UiTemplateGalleryModel> = {}): UiTemplateGalleryModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTemplateGalleryModelContent = UiTemplateGalleryModel["content"];

export function mockUiTemplateGalleryModelContent({
    title = "Title here",
    templates = [mockTrelloTemplateModel()],
    ...optionals
}: Partial<UiTemplateGalleryModelContent> = {}): UiTemplateGalleryModelContent {
    return {
        title,
        templates,
        ...optionals
    };
}
